var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info-4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_67902",
    "data-name": "Path 67902",
    d: "M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Zm0,19.25A8.25,8.25,0,1,1,19.25,11,8.25,8.25,0,0,1,11,19.25Z",
    transform: "translate(0 0)",
    fill: "#5784d5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67903",
    "data-name": "Path 67903",
    d: "M11.386,9.545h-.275A1.446,1.446,0,0,0,9.64,10.822a1.375,1.375,0,0,0,1.247,1.461v4.262a1.375,1.375,0,1,0,2.75,0V11.8a2.25,2.25,0,0,0-2.25-2.25Z",
    transform: "translate(-0.803 -0.795)",
    fill: "#5784d5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67904",
    "data-name": "Path 67904",
    d: "M11.687,8.18a1.572,1.572,0,1,0-1.113-.46A1.573,1.573,0,0,0,11.687,8.18Z",
    transform: "translate(-0.843 -0.42)",
    fill: "#5784d5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo4);
export default __webpack_public_path__ + "static/media/info-4.5703954ef258357725b386c58c08a6fd.svg";
export { ForwardRef as ReactComponent };